/**
 * Flow A · onboarding routes — WP-C.
 *
 * A1 `/welcome/language` · A2 `/welcome` · A3 `/auth/phone` · A4 `/auth/code`
 * A5 `/onboarding/profile` · A7 `/auth/login`
 * and the undrawn page A7's two recovery links open: `/auth/help` (W2-12, `recovery.tsx`,
 * which says it takes no requests until a Worker route receives one)
 *
 * A6 is absent on purpose. The manifest carries it with `route: null`: permission is an
 * in-context sheet, asked at the moment of need and never during onboarding. Its panel
 * is exported from `./permission-sheet.js` and mounted by the screen that needs it.
 *
 * App.tsx mounts this array; it is not edited from here — three other work packages are
 * registering their own groups against the same file.
 */
import type { RouteObject } from 'react-router-dom';
import { withSurfaceStates } from '../../states/boundary.js';
import { LanguageScreen } from './language.js';
import { WelcomeScreen } from './welcome.js';
import { PhoneScreen } from './phone.js';
import { CodeScreen } from './code.js';
import { ProfileScreen } from './profile.js';
import { LoginScreen } from './login.js';
import { RecoveryScreen, RECOVERY_PATH } from './recovery.js';

/**
 * WP-K · state branches. `withSurfaceStates` wraps every element of this group in the
 * boundary for its matrix column (onboarding · অনবোর্ডিং); see
 * `apps/web/src/states/boundary.tsx`. It changes nothing about the healthy render — no
 * state resolves unless an API error body says so, so the screens below are untouched
 * and their fidelity gate still measures what it measured.
 */
export const onboardingRoutes: RouteObject[] = withSurfaceStates('onboarding', [
  { path: '/welcome/language', element: <LanguageScreen /> },
  { path: '/welcome', element: <WelcomeScreen /> },
  { path: '/auth/phone', element: <PhoneScreen /> },
  { path: '/auth/code', element: <CodeScreen /> },
  { path: '/onboarding/profile', element: <ProfileScreen /> },
  { path: '/auth/login', element: <LoginScreen /> },
  { path: RECOVERY_PATH, element: <RecoveryScreen /> },
]);
